module.exports = __webpack_public_path__ + "static/media/NI.889acd54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/NI.svg
// module id = 329
// module chunks = 0